import moment from "moment";

//set first day of the week as monday
moment.updateLocale("es", {
    week: {
        dow: 1,
    },
});

export default (date) => {
    const firstDayOfMonth = moment(date).startOf("month");
    const firstDayOfWeek = moment(firstDayOfMonth).startOf("week");
    const offset = moment(firstDayOfMonth).diff(firstDayOfWeek, "day");

    return Math.ceil((moment(date).date() + offset) / 7);
};
